import { render } from "./SearchResultsCategory.vue?vue&type=template&id=119a0d3a&scoped=true"
import script from "./SearchResultsCategory.vue?vue&type=script&lang=js"
export * from "./SearchResultsCategory.vue?vue&type=script&lang=js"

import "./SearchResultsCategory.vue?vue&type=style&index=0&id=119a0d3a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119a0d3a"]])

export default __exports__